import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/header.css';

const Header = () => {
  const { i18n, t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const onScroll = () => {
      const header = document.getElementById('nx-header');
      if (header) {
        header.style.boxShadow = window.scrollY > 8 ? '0 8px 30px rgba(15,27,54,.10)' : 'none';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    setLanguage(lang);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <header id="nx-header" className="header">
      <div className="header-container">
        <div className="header-logo">
          <a href="/">
            <img src="/assets/nexus-mark.png" alt="Nexus" className="logo-mark" />
            <div className="logo-text">
              <div className="logo-name">nexus</div>
              <div className="logo-subtitle">AFRICA SOLUTIONS</div>
            </div>
          </a>
        </div>

        <nav className="nav-desktop">
          <a href="#services" onClick={() => scrollToSection('services')}>{t('nav.expertises')}</a>
          <a href="#work" onClick={() => scrollToSection('work')}>{t('nav.realisations')}</a>
          <a href="#team" onClick={() => scrollToSection('team')}>{t('nav.team')}</a>
          <a href="#about" onClick={() => scrollToSection('about')}>{t('nav.about')}</a>
          <a href="#contact" onClick={() => scrollToSection('contact')}>{t('nav.contact')}</a>
        </nav>

        <div className="header-actions">
          <div className="language-toggle">
            <button 
              className={language === 'fr' ? 'active' : ''} 
              onClick={() => handleLanguageChange('fr')}
            >
              FR
            </button>
            <button 
              className={language === 'en' ? 'active' : ''} 
              onClick={() => handleLanguageChange('en')}
            >
              EN
            </button>
          </div>
          
          <a href="#contact" onClick={() => scrollToSection('contact')} className="btn-cta">
            {t('nav.quote')}
          </a>

          <button 
            className="menu-toggle" 
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="mobile-menu">
          <a href="#services" onClick={() => scrollToSection('services')}>{t('nav.expertises')}</a>
          <a href="#work" onClick={() => scrollToSection('work')}>{t('nav.realisations')}</a>
          <a href="#team" onClick={() => scrollToSection('team')}>{t('nav.team')}</a>
          <a href="#about" onClick={() => scrollToSection('about')}>{t('nav.about')}</a>
          <a href="#contact" onClick={() => scrollToSection('contact')}>{t('nav.contact')}</a>
          <a href="#contact" onClick={() => scrollToSection('contact')} className="btn-cta">
            {t('nav.quote')}
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
